/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface InitiateNetsTerminalPaymentV2Request
 */
export interface InitiateNetsTerminalPaymentV2Request {
    /**
     * 
     * @type {number}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    paymentReference: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    printReceipt: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateNetsTerminalPaymentV2Request
     */
    shopperLocale?: string | null;
}



/**
 * Check if a given object implements the InitiateNetsTerminalPaymentV2Request interface.
 */
export function instanceOfInitiateNetsTerminalPaymentV2Request(value: object): value is InitiateNetsTerminalPaymentV2Request {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('printReceipt' in value) || value['printReceipt'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function InitiateNetsTerminalPaymentV2RequestFromJSON(json: any): InitiateNetsTerminalPaymentV2Request {
    return InitiateNetsTerminalPaymentV2RequestFromJSONTyped(json, false);
}

export function InitiateNetsTerminalPaymentV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateNetsTerminalPaymentV2Request {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'printReceipt': json['printReceipt'],
        'terminalId': json['terminalId'],
        'shopperLocale': json['shopperLocale'] === undefined ? undefined : json['shopperLocale'] === null ? null : json['shopperLocale'],
    };
}

export function InitiateNetsTerminalPaymentV2RequestToJSON(json: any): InitiateNetsTerminalPaymentV2Request {
    return InitiateNetsTerminalPaymentV2RequestToJSONTyped(json, false);
}

export function InitiateNetsTerminalPaymentV2RequestToJSONTyped(value?: InitiateNetsTerminalPaymentV2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'printReceipt': value['printReceipt'],
        'terminalId': value['terminalId'],
        'shopperLocale': value['shopperLocale'],
    };
}

